import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Loading = ({ message = 'Loading...' }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: theme?.palette?.background?.default,
                gap: 2,
            }}
        >
            <CircularProgress 
                size={50}
                sx={{ color: theme?.palette?.primary?.main }} 
            />
            <Typography
                variant="body1"
                sx={{
                    color: theme?.palette?.text?.secondary,
                    fontWeight: 500,
                }}
            >
                {message}
            </Typography>
        </Box>
    );
};

export default Loading;